<template>
  <div>
    <nav
      class="navbar navbar-expand-md navbar-dark fixed-top bg-dark"
      style="margin-left: 8rem; margin-right: 8rem"
    >
      <div class="container-fluid">
        <a class="navbar-brand" href="#">Fleurop CMS Demo</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav me-auto mb-2 mb-md-0">
            <li class="nav-item">
              <router-link
                class="nav-link"
                active-class="active"
                :to="{ name: 'Preview1Index' }"
              >
                Preview 1
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                active-class="active"
                :to="{ name: 'Preview2Index' }"
              >
                Preview 2
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <main class="container">
      <router-view></router-view>
    </main>
  </div>
</template>

<style>
@font-face {
  font-family: "Helvetica";
  src: local("Helvetica"), url("./assets/fonts/Helvetica.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "TheSans-Light";
  src: local("TheSans Light"), local("TheSans-Light"),
    url("./assets/fonts/TheSans-Light.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "TheSans-Bold";
  src: local("TheSans Bold"), local("TheSans-Bold"),
    url("./assets/fonts/TheSans-Bold.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "TheSerif-Light";
  src: local("TheSerif Light"), local("TheSerif-Light"),
    url("./assets/fonts/TheSerif-Light.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "TheSerif-Regular";
  src: local("TheSerif Regular"), local("TheSerifRegular"),
    url("./assets/fonts/TheSerif-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  font-family: TheSans-Light, Helvetica, Arial, sans-serif !important;
  color: #231f20;
  /* line-height: 1.66666; */
  font-weight: 300 !important;
}

h1,h2,h3 {
  font-family: TheSerif-Light, Helvetica, Arial, sans-serif !important;
  color: #231f20;
  /* line-height: 1.66666; */
  font-weight: 300 !important;
}
</style>
